import React, { FC } from 'react';
import {
  CloseIconStyled,
  ExtraActionsWrapper,
  FileIconStyled,
  FileInfo,
  FileInfoWrapper,
  FileTitle,
  TypographyGlobalStyle,
  UploadedFileWrapper,
} from './UploadedFile.styled';
import { ProgressBar } from '../ProgressBar';
import { useTheme } from '../../../ThemeProvider';
import { SVGComponent } from '../../../FileDropzone/FileDropzone';

interface UploadedFileProps {
  file: File;
  index: number;
  handleRemoveFile: (file: File) => void;
  progress: number;
  Icon?: SVGComponent;
}

const UploadedFile: FC<UploadedFileProps> = ({
  file,
  index,
  handleRemoveFile,
  progress,
  Icon = FileIconStyled,
}: UploadedFileProps) => {
  const theme = useTheme();
  const isUploaded = progress === 100;

  return (
    <UploadedFileWrapper key={index}>
      <FileInfoWrapper>
        <FileInfo>
          <Icon />
          <div>
            <FileTitle
              variant="chipsSmall"
              color={theme.palette.text.paragraph.primary}
              key={file.name}
            >
              {file.name}
            </FileTitle>
            <TypographyGlobalStyle
              color={theme.palette.text.paragraph.secondary}
            >
              {`${file.size} B`}
            </TypographyGlobalStyle>
          </div>
        </FileInfo>
        <ExtraActionsWrapper>
          <CloseIconStyled
            data-testid="removeFile"
            onClick={() => handleRemoveFile(file)}
          />
          {!isUploaded && (
            <TypographyGlobalStyle
              color={theme.palette.text.paragraph.secondary}
            >
              {progress}%
            </TypographyGlobalStyle>
          )}
        </ExtraActionsWrapper>
      </FileInfoWrapper>
      {!isUploaded && <ProgressBar progress={progress} />}
    </UploadedFileWrapper>
  );
};

export default UploadedFile;
